import { useState, useEffect, useMemo } from "react";
import { BiPlus } from "react-icons/bi";
import { GrAscend, GrDescend } from "react-icons/gr";
import { PiMagnifyingGlass } from "react-icons/pi";
import { VscOrganization } from "react-icons/vsc";
import TableRowsLoader from "../Loaders/TableRowsLoader";
import { TbReload } from "react-icons/tb";
import LogsTable from "./LogsTable";
import FormatDateTime from "../Functions/FormatDate";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const LogsMain = ({
    account_id
}) => {
    const {t} = useLanguage()
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [data, setDatata] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        if (!account_id) return;
        setLoading(true);
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_logs`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ account_id: account_id }),
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.error || "Failed to fetch");

            setDatata(result.data || []);
        } catch (err) {
            console.error("Error fetching members:", err);
        } finally {
            setTimeout(() => setLoading(false), 500);
        }
    };

    useEffect(() => {
        fetchData();
    }, [account_id]);

    const filteredAndSortedData = useMemo(() => {
        if (!data) return [];

        let result = data.filter((item) => {
            const term = searchTerm.toLowerCase();
            const idMatch = item.id?.toLowerCase().includes(term);
            const event_typeMatch = item.event_type?.toLowerCase().includes(term);
            const messageMatch = item.message?.toLowerCase().includes(term);
            const severityMatch = item.severity == term;
            const local_created_at = FormatDateTime(item.created_at)
            const created_at = local_created_at.toLowerCase().includes(term);


            return idMatch || event_typeMatch || messageMatch || severityMatch || created_at;
        });

        result.sort((a, b) => {
            const nameA = a.created_at?.toLowerCase() || "";
            const nameB = b.created_at?.toLowerCase() || "";
            return sortOrder === "desc"
                ? nameA.localeCompare(nameB)
                : nameB.localeCompare(nameA);
        });

        return result;
    }, [data, searchTerm, sortOrder]);

    if (loading) return <TableRowsLoader />;

    return (
        <div className="mainframe_item">
            <div className="mainframe_item_header">
                <p className="mainframe_item_title fade-in">{t.logs.title}</p>
                <div className="mainframe_item_subtitle fade-in">
                    {data.length === 0 ? (
                        <div className="empty_org_mex_cont">
                            <p>{t.logs.empty_subtitle}</p>
                            <div className="empty_org_img">
                                <p className="empty_org_img_title">
                                    <i><VscOrganization /></i> {t.logs.quest_title}
                                </p>
                                <p className="empty_org_img_subtitle">
                                    {t.logs.quest_answ}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <p>{t.logs.subtitle}</p>
                    )}
                </div>
            </div>

            {(data.length > 0 || searchTerm) && (
                <div className="filter_body_mainframe">
                    <div className="filtering_mainframe">
                        <div className="filtering_mainframe_btn_cont fade-in">
                            {data.length > 1 && (
                                <>
                                    <button className={`filter_btn ${sortOrder === "asc" ? "active" : ""}`} onClick={() => setSortOrder("asc")} title="A-Z">
                                        <GrAscend />
                                    </button>
                                    <button className={`filter_btn ${sortOrder === "desc" ? "active" : ""}`} onClick={() => setSortOrder("desc")} title="Z-A">
                                        <GrDescend />
                                    </button>
                                </>
                            )}
                            <button className="filter_btn" onClick={() => fetchData()} title={t.reload}>
                                <TbReload />
                            </button>
                        </div>
                        <div className="filter_input_cont fade-in">
                            <input
                                className="filter_input"
                                placeholder={t.search_filter}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <span className="filter_input_icon"><PiMagnifyingGlass /></span>
                        </div>
                    </div>

                    <LogsTable
                        data={filteredAndSortedData}
                    />
                </div>
            )}

        </div>
    );
};

export default LogsMain;